import { RegisterTypes } from 'src/app/accounts/enums/register-types.enums';
import { OnboardingIntentStep } from 'src/app/shared/enums/intent.enum';
import { OnboardingPaths } from 'src/app/shared/interfaces/intent.interface';

const NIPT_STEPS: OnboardingPaths = {
  [OnboardingIntentStep.Welcome]: { path: '/onboarding/nipt/welcome' },
  [OnboardingIntentStep.Register]: {
    path: '/accounts/create',
    queryParams: { type: RegisterTypes.NIPT },
  },
  [OnboardingIntentStep.Newsletter]: { path: '/accounts/newsletters' },
  [OnboardingIntentStep.Caution]: { path: '/accounts/caution' },
  [OnboardingIntentStep.Login]: { path: '/accounts/check' },
  [OnboardingIntentStep.Onboarding]: { path: '/onboarding/details' },
  [OnboardingIntentStep.PushNotifications]: {
    path: '/onboarding/push-notifications',
  },
  [OnboardingIntentStep.Claim]: { path: '/onboarding/nipt/claim' },
  [OnboardingIntentStep.End]: { path: '/nipt/results' },
};

export default NIPT_STEPS;
